export interface RankItem {
  rank: number;
  name: string;
  note: string;
  hot: number;
  trend: "up" | "flat" | "down";
  category: string;
}

export const ranking: RankItem[] = [
  { rank: 1, name: "每日速报入口", note: "更新时间最勤，几乎每小时都有新料", hot: 9860, trend: "up", category: "速报" },
  { rank: 2, name: "事件归档大厅", note: "补课前因后果最完整的一条路径", hot: 8420, trend: "up", category: "归档" },
  { rank: 3, name: "热搜回声专线", note: "跟热搜节奏走，适合看当下最热的", hot: 7935, trend: "flat", category: "热搜" },
  { rank: 4, name: "分类筛选通道", note: "想按题材挑的，从这里进去最省事", hot: 6810, trend: "up", category: "分类" },
  { rank: 5, name: "综艺短讯集合", note: "节目播出后两小时内就有整理", hot: 6120, trend: "flat", category: "综艺" },
  { rank: 6, name: "图集精选入口", note: "配图为主，信息密度高但翻起来快", hot: 5480, trend: "up", category: "图集" },
  { rank: 7, name: "网红动态墙", note: "更新频繁，适合每天固定刷一次", hot: 4905, trend: "down", category: "动态" },
  { rank: 8, name: "长贴讨论集合", note: "偏讨论向，适合愿意慢慢看的", hot: 4370, trend: "flat", category: "论坛" },
  { rank: 9, name: "老瓜回顾归档", note: "旧料重新整理，常有意想不到的细节", hot: 3610, trend: "up", category: "老瓜" },
  { rank: 10, name: "冷门口袋名单", note: "内容干净，更新不快但很稳", hot: 2980, trend: "flat", category: "冷门" },
];